<button (click)="taskClick.emit(task())">
  <oph-icon [name]="'color-icons/' + task().icon || 'alarm'" [size]="34" class="task-icon"></oph-icon>
  <span>{{ task().label }}</span>

  <div class="project" [style.background-color]="project()?.color || '#E5E3DC'">
    <span>{{ project()?.label }}</span>
  </div>
  @if (expired()) {
    <div class="expired-day">{{ task().endDateTime | dayAbbreviation }}</div>
  }
</button>
